var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "30px",
    viewBox: "0 0 48 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Card/Visa") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "33.4268571 10.7963143 33.4268571 0 0 0 0 10.7963143"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 0,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ordering/Cart/L/Default",
    transform: "translate(-147.000000, -336.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(0.000000, 29.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(71.000000, 307.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cart&Checkout/CreditCard/Visa",
    transform: "translate(76.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Card/Visa"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(6.000000, 9.428571)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5526286,0.1926 L14.3189143,10.6326 L11.6172,10.6326 L13.8517714,0.1926 L16.5526286,0.1926 Z M27.9157714,6.93231429 L29.3386286,3.01345714 L30.1554857,6.93231429 L27.9157714,6.93231429 Z M30.9303429,10.6326 L33.4272,10.6326 L31.2492,0.1926 L28.9417714,0.1926 C28.4240571,0.1926 27.9860571,0.494314286 27.7923429,0.958028571 L23.7406286,10.6326 L26.5743429,10.6326 L27.1392,9.07345714 L30.6046286,9.07345714 L30.9303429,10.6326 Z M23.8794857,7.22545714 C23.8923429,4.46631429 20.0694857,4.31631429 20.0960571,3.08717143 C20.1046286,2.71088571 20.4612,2.31231429 21.2412,2.21031429 C21.6286286,2.15974286 22.6940571,2.12117143 23.9043429,2.6766 L24.3783429,0.461742857 C23.7303429,0.227742857 22.8920571,-0.000257142857 21.8523429,-0.000257142857 C19.1832,-0.000257142857 17.3034857,1.42002857 17.2880571,3.45402857 C17.2717714,4.95574286 18.6294857,5.79402857 19.6537714,6.2946 C20.7054857,6.80545714 21.0577714,7.13374286 21.0552,7.59317143 C21.0466286,8.29174286 20.2134857,8.60202857 19.4377714,8.61145714 C18.0800571,8.63545714 17.2906286,8.24631429 16.6640571,7.95574286 L16.1737714,10.2426 C16.8046286,10.5323143 17.9686286,10.7817429 19.1780571,10.7963143 C22.0143429,10.7963143 23.8709143,9.39317143 23.8794857,7.22545714 L23.8794857,7.22545714 Z M12.6929143,0.1926 L8.3172,10.6326 L5.4612,10.6326 L3.30805714,2.30031429 C3.17605714,1.78602857 3.06205714,1.60088571 2.6652,1.38317143 C2.0172,1.03002857 0.944914286,0.700028571 -0.000514285714,0.494314286 L0.0654857143,0.1926 L4.66062857,0.1926 C5.24691429,0.1926 5.7732,0.580885714 5.90605714,1.25717143 L7.04348571,7.29917143 L9.85405714,0.1926 L12.6929143,0.1926 L12.6929143,0.1926 Z",
    id: "Fill-1",
    fill: "#10347E",
    mask: "url(#mask-2)"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.555350ca.svg";
export { ForwardRef as ReactComponent };